const config = {
  env: "local",
  apiUrl: "https://api.reorojewellery.com/api/",
  //apiUrl: "http://192.168.0.56:5002/api/",
 // apiUrl: "http://192.168.0.58:5900/api/",  //ip local
};

export default config;
